import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApplicationState } from '@store/application-store';
import { tap, take, catchError } from 'rxjs';
import { Observable, of } from 'rxjs';
import { ITable } from '@common/models/table';
import { DashboardItem } from '@dashboards/models/dashboard-item';
import { IContext } from '@context/models/context';
import { ArrearsTransactionDrillDownParamsModel } from '../models/arrears-transaction-drill-down-params.model';
import { ToastrService } from 'ngx-toastr';
import * as arrearsTransactionTableActions from '../actions/arrears-transaction-table.action';
import { ArrearsTransactionTableHttpService } from './arrears-transaction-table-http.service';
import * as arrearsTransactionTableSelectors from '../selectors/arrears-transaction-table.selectors';

@Injectable()
export class ArrearsTransactionTableService {

  constructor(protected store: Store<ApplicationState>,
    private readonly arrearsTransactionTableHttpService: ArrearsTransactionTableHttpService,
    private readonly messageService: ToastrService) { }

   getTableDataFromApi(dashboardItem: DashboardItem, context: IContext, paramsModel: ArrearsTransactionDrillDownParamsModel): Observable<ITable> {
     this.store.dispatch(new arrearsTransactionTableActions.Load(dashboardItem, paramsModel));
     return this.arrearsTransactionTableHttpService.getTable(context, paramsModel, dashboardItem)
      .pipe(
        catchError((err) => {
          this.messageService.error("Unable to load transactions", "Load Error");
          return of(undefined);
        }),
        tap((table: ITable) => {
          this.store.dispatch(new arrearsTransactionTableActions.LoadComplete(table, dashboardItem));
        }),
        take(1)
      );
  }

  loadTable(dashboardItem: DashboardItem, context: IContext, paramsModel: ArrearsTransactionDrillDownParamsModel): void {   
    this.getTableDataFromApi(dashboardItem, context, paramsModel).subscribe();
  }

  hasTransactionData(dashboardItem: DashboardItem): Observable<boolean> {
    return this.store.select(arrearsTransactionTableSelectors.hasArrearsTransactionData(dashboardItem.id.toString()));
  }

  getDrillDownModel(dashboardItem: DashboardItem): Observable<ArrearsTransactionDrillDownParamsModel> {
    return this.store.select(arrearsTransactionTableSelectors.getDrillDownModel(dashboardItem.id.toString()));
  }

  getArrearsTransactionTable(dashboardItem: DashboardItem): Observable<ITable> {
    return this.store.select(arrearsTransactionTableSelectors.getArrearsTransactionsWithDataKey(dashboardItem.id.toString(), dashboardItem.widgetConfigId));
  }

  clearArrearsTransactionTable(dashboardItem: DashboardItem): void {
    this.store.dispatch(new arrearsTransactionTableActions.Clear(dashboardItem));
  }

}
